<template>
  <div class="register absolute">
    <div class="showbox" v-if="showbox">
      <div class="showTile">
        <img src="@assets/images/logo.png" alt="">

        小将文化 申请获得
      </div>
      <strong>
        以下权限
      </strong>
      <p>
        获得你的公开信息（昵称、头像、地区及性别）
      </p>

      <button  @click="btnfalse()">同意</button>
    </div>

    <!-- 选卡券 -->
    <SwitchAccounts :showCard="showCard" @cancel="cancelAccounts" :cardList="cardList" @changeAccount="checkedCard" :title="''"></SwitchAccounts>

    <div class="shading" v-if="false">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logoWhrite.png" v-else />
      </div>
    </div>
    <div class="img">
      <img :src="logoUrl" alt="" />
      <!-- <img src="@assets/images/loginbanner.jpeg" alt="" /> -->
    </div>
    <!--  -->
    <div class="whiteBg" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper" v-if="!this.isOlderVersion">
        <div
          class="item"
          :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="navTap(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="title acea-row row-center-wrapper" v-if="this.isOlderVersion">
          <div
          class="item on"
        >
          手机号登录
        </div>
      </div>

      <div class="list" :hidden="current !== 0">
        <!-- <h2 class="htitle">登录</h2> -->
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true" v-if="false">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <label for="">账号</label>
              <input
                type="text"
                placeholder="请输入账号"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true" v-if="false">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <label for="">密码</label>
              <input
                type="password"
                placeholder="请输入密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        <div
          class="forgetPwd"
          @click="$router.push({ name: 'RetrievePassword' })"
          v-if="false"
        >
          <span class="iconfont icon-wenti"></span>忘记密码
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" style="input::-webkit-input-placeholder{position：relative；left：20px;" />
          </div>
        </div>
        <!--  -->
        <div class="acea-row row-between row-bottom item two-item" v-if="!this.isOlderVersion">
             <input
              type="text"
              placeholder="验证码"
              class="codeInput"
              v-model="imgCode"
            />
            <img class="img-code" @click="getCapt" :src="imgCodeUrl" />
        </div>
        <!--  -->
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current !== 1">确认</div>
      <div class="logon" @click="submit" :hidden="current == 1">确认</div>
      <div class="tip" v-if="false">
        没有卡号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div>
    </div>
    <!-- ↑ -->
    <div class="whiteBg" v-else>
      <div class="title">注册卡号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="填写您的登录卡密"
              v-model="password"
            />
          </div>
        </div>
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有卡号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
    <div class="bottom" v-if="false"></div>

    <SpringFrame ref="sfComponent" :isShow="frameIsShow" :btnCont="frameBtnCont" :types="frameTypes" :content="frameContent" :btnText="frameBtnText" @closeMask="closeMaskSFn"></SpringFrame>
    <BindCard ref="bindComponent" :isShow="bindCardIsShow" @closeMaskFn="closeBdcFn" @submitFn="bindSubmit"></BindCard>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  islogin,
  login,
  loginMobile,
  loginCouponLogin,
  registerVerify,
  register,
  addNewCouponFn
} from "@api/user";
import { getLogo,wechatAuth } from "@api/public";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { parseQuery } from "@utils";
const BACK_URL = "login_back_url";
import {toAuth} from "@libs/wechat";

import SwitchAccounts from "@components/SwitchAccounts.vue";
import SpringFrame from "@components/SpringFrame.vue";
import BindCard from "@components/BindCard.vue";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  components: {
    SwitchAccounts,
    SpringFrame,
    BindCard
  },
  data: function() {
    return {
      navList: ["账号登录", "手机登录"],
      current: 0,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      showbox: false,
      showCard: false, //选择卡券
      cardList:[],
      imgCode: "", //图片验证码字
      imgCodeUrl: "https://new-gzh.xiaojiangwh.com/api/login/captcha", //图片验证码图
      // 提示框-信息
      frameIsShow: false,
      frameTypes: '',
      frameContent: {
        title: '',
        tips: ''
      },
      frameBtnText :{
        no: '',
        yes: ''
      },
      frameBtnCont: '',
      // 绑卡券
      bindCardIsShow: false,
      // 登录信息
      loginInfo: {},
      isOlderVersion: false // 老年版
    };
  },
  watch: {
    captcha: function (val) {
      if (val.length > 6) this.captcha = val.slice(0,6);
    }
  },
  created() {
    if (cookie.get("loginphone")) {
      this.current = 1;
      this.isOlderVersion = true;
    }
  },
  mounted: function() {
    this.getLogoImage();
    // islogin();
    // console.log(islogin());

    this.btnfalse();
  },
  methods: {
    // 提示框-展开
    closeMaskSFn(val) {
       this.frameIsShow = val;
    },
    // 绑卡弹框-开关
    closeBdcFn(val) {
      this.bindCardIsShow = val;
    },
    // 账号密码绑定
    bindSubmit(data) {
      let info = {
        account: data.account,
        password: data.passWord
      }
      addNewCouponFn(info).then((res)=>{
          if (res.status == 200) {
              cookie.set("couponId", data.account);
              this.loginAgain();
              //
              this.frameTypes = 'type1';
              this.frameContent.title = res.msg;
              this.frameContent.tips = "";
              this.frameContent.sfDetermine = ()=>{
                this.closeMaskSFn(false);
                const backUrl = cookie.get(BACK_URL) || "/home";
                cookie.remove(BACK_URL);
                this.$router.replace({ path: backUrl });
              };
              this.frameBtnText.no = "";
              this.frameBtnText.yes = "";
              this.frameBtnCont = "进入专区";
              this.closeMaskSFn(true);
              this.closeBdcFn(false);
          }
      }).catch((err)=>{
         if (err.data.status == 400 && err.msg.indexOf("该卡券已被绑定") != -1 ) {
            this.frameTypes = "type2";
            this.frameContent.title = err.data.data.title;
            this.frameContent.tips = err.data.data.desc;
            this.frameContent.sfDetermine = ()=>{
              this.closeMaskSFn(false);
            };
            this.frameContent.no = '';
            this.frameContent.yes = '';
            this.frameBtnCont = "确定";
            this.closeMaskSFn(true);
          } else {
            this.$dialog.error(err.msg);
          }
      })
      // this.closeBdcFn(false);
    },
    // 绑卡后-登录
    loginAgain() {
      let data = this.loginInfo;
      this.$store.commit("LOGIN", data.token, data.expires_time);
      cookie.set("temporary_login_status", data.token);
    },
    cancelAccounts(val) {
      this.showCard = val;
    },
    //
    getCapt: function () {
      let imgPath = this.imgCodeUrl.split('?')[0]+'?id='+parseInt(Math.random()*100000);
      this.imgCodeUrl = imgPath;
    },
    // 选择卡券登录
    checkedCard: function (val) {
      let {showCard, id, kahao} = val;
      loginCouponLogin({id: id}).then((res)=>{
        if(!res.data) return;
        this.cancelAccounts(showCard);
        let data = res.data;
        this.$store.commit("LOGIN", data.token, data.expires_time);
        cookie.set("couponId", kahao);
        cookie.set("temporary_login_status", data.token);
        const backUrl = cookie.get(BACK_URL) || "/home";
        cookie.remove(BACK_URL);
        if (cookie.get("loginphone")) {
          cookie.remove("loginphone");
        }
        this.$router.replace({ path: backUrl });
        // this.$router.push("/home");
      }).catch((err)=>{
        console.log(err);
      })
    },
    btnfalse(){
      // 暂时隐藏
      // if (cookie.get("temporary_login_status") && (cookie.get("expires") > new Date().getTime())) {
      //   this.$router.replace("/home");
      // } else {
        if (!this.isOlderVersion) {
          toAuth();
        }
      // }
      if (this.isOlderVersion) {
        this.showbox = false;
      } else {
        this.showbox = !this.showbox;
      }
    },

    async getLogoImage() {
      let that = this;
      getLogo(3).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    // 手机号登录接口
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;

          // 原来判断是否有数组，说明有没有绑卡
          // if (res.data && res.data.couponList) {
          //   let arr = [];
          //   res.data.couponList.forEach((item, ind)=>{
          //     arr.push({
          //       coupon_price: item.coupon_price,
          //       id: item.id,
          //       cate_name: item.cate_name,
          //       imgUrl: item.imgUrl,
          //       type: item.type,
          //       title: item.title
          //     })
          //   })
          //   this.cardList = arr;
          //   this.showCard = true;
          // } else {
          //   that.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
          //   cookie.set("temporary_login_status", data.token);
          //   const backUrl = cookie.get(BACK_URL) || "/home";
          //   cookie.remove(BACK_URL);
          //   that.$router.replace({ path: backUrl });
          //   this.$router.push("/home");
          // }


          // 判断是否绑卡
          if (res.data && res.data.is_bind == 1 && res.data.coupon_lst) {

              let data = res.data.coupon_lst;
              let list1 = Object.keys(data);
              let list2 = Object.values(data);
              let _list = [];
              list2.forEach((val, ind)=>{
                let title = list1[ind] || "";
                _list.push({
                    id: val.child[0].id,
                    cate_name: title,
                    imgUrl: val.imgUrl,
                    type: val.child[0].type,
                    title: val.child[0].cate_name || '',
                    cardNum: val.total_coupon_num || 0,
                    all_price: val.total_coupon_price || 0,
                    kahao: val.child[0].title
                })
              });
              this.cardList = _list;
              this.cancelAccounts(true);

          } else if (res.data.is_bind == 1 && !res.data.coupon_lst) {
            // 手机绑定一张卡-直接登录
              this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
              cookie.set("temporary_login_status", data.token);
              const backUrl = cookie.get(BACK_URL) || "/home";
              cookie.remove(BACK_URL);
              if (cookie.get("loginphone")) {
                cookie.remove("loginphone");
              }
              this.$router.replace({ path: backUrl });
          } else {
              // 暂存一下登录信息
              this.loginInfo = res.data;
              this.frameTypes = 'type3';
              this.frameContent.title = "您还未绑定卡券";
              this.frameContent.tips = "";
              this.frameBtnText.no = "取消";
              this.frameBtnText.yes = "去绑定";
              this.frameContent.sfDetermine = ()=>{
                this.closeMaskSFn(false);
                this.closeBdcFn(true);
              };
              this.closeMaskSFn(true);
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      if (this.imgCode) {
        this.getCodeNum();
      } else if (this.isOlderVersion) {
        this.getCodeNum();
      } else {
        that.$dialog.error("请输入验证码！");
      }
    },
    getCodeNum: async function () {
        let that = this;
        if (that.formItem == 2) that.type = "register";
      await registerVerify({ phone: that.account, type: that.type,  verify: that.imgCode })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
      this.account = "";
      console.log(this.current);
    },
    // 账号-密码--登录
    async submit() {
      const { account, password } = this;
      try {
        this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ]
        }).validate({ account, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password })
        .then(({ data }) => {
          let time = new Date(data.expires_time).getTime();
          // console.log(time);
          this.$store.commit("LOGIN", data.token, time);
          cookie.set("temporary_login_status", data.token);
          const backUrl = cookie.get(BACK_URL) || "/home";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: "/home" });
          // this.$router.push("/home");
        })
        .catch(err => {
          if (err.data.status == 400 && err.msg.indexOf("该卡券已被绑定") != -1 ) {
            this.frameTypes = "type2";
            this.frameContent.title = err.data.data.title;
            this.frameContent.tips = err.data.data.desc;
            this.frameContent.sfDetermine = ()=>{
              this.closeMaskSFn(false);
            };
            this.frameContent.no = '';
            this.frameContent.yes = '';
            this.frameBtnCont = "确定";
            this.closeMaskSFn(true);
          } else {
            this.$dialog.error(err.msg);
          }
        });
    }
  }
};
</script>
<style>
.home {
  display: none !important;
}
/*  */
.showbox{
  position: fixed;
  width:100%;
  height:100%;
  z-index:666;
  background:#fff;
  color:rgba(0,0,0,0.9);
}
.showbox button{
  width:184px;
  background:#07c160;
  color:#fff;
  padding:10px 20px;
  display:block;
  margin:100px auto;
  border-radius:4px;
}
.showbox .showTile{
  overflow: hidden;
  line-height:30px;
  margin:40px 0 0 40px;
}
.showbox .showTile img{
  height:30px;
  margin-right:15px;
  background:#f5f5f5;
  display: block;
  float: left;
}
.showbox strong{
  font-size:24px;
  font-weight:normal;
  margin:20px 0 0 40px;
  display:block;
}
.showbox p{
  font-size:16px;
  margin:40px 0 0 40px;
}
/*  */
.img-code {
  width: 2rem;
  height: .8rem;
}
.codeInput {
  width: 3.4rem !important;
  height: .38rem;
  box-sizing: border-box;
  padding-left: .3rem;
}
.two-item {
  padding-top: .3rem !important;
}
</style>
